import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { notificationsApi } from '../../api/notifications.api'
import { EmptyState } from '../../components/ui/EmptyState'
import styles from './NotificationsDropdown.module.css'

export function NotificationsDropdown() {
  const [open, setOpen] = useState(false)
  const navigate = useNavigate()
  const queryClient = useQueryClient()

  const countQuery = useQuery({ queryKey: ['notifications', 'unread-count'], queryFn: async () => (await notificationsApi.unreadCount()).data.count, refetchInterval: 60_000 })
  const listQuery = useQuery({ queryKey: ['notifications', 'list'], queryFn: async () => (await notificationsApi.list()).data, enabled: open })

  const markReadMutation = useMutation({
    mutationFn: (id: string) => notificationsApi.markRead(id),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ['notifications'], exact: false }),
  })

  const markAllMutation = useMutation({
    mutationFn: () => notificationsApi.markAllRead(),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ['notifications'], exact: false }),
  })

  const unread = countQuery.data ?? 0

  return (
    <div className={styles.wrap}>
      <button className={styles.bellBtn} onClick={() => setOpen((v) => !v)} aria-label="Benachrichtigungen">
        🔔
        {unread > 0 ? <span className={styles.badge}>{unread > 9 ? '9+' : unread}</span> : null}
      </button>

      {open ? (
        <div className={styles.panel}>
          <div className={styles.panelHeader}>
            <span>Benachrichtigungen</span>
            {unread > 0 ? (
              <button onClick={() => markAllMutation.mutate()} style={{ background: 'none', border: 'none', color: 'var(--accent-10)', cursor: 'pointer', fontSize: 'var(--text-xs)' }}>
                Alle gelesen
              </button>
            ) : null}
          </div>
          {listQuery.data?.length === 0 ? (
            <EmptyState mascot mascotSize={44} title="Keine Benachrichtigungen" />
          ) : (
            listQuery.data?.map((n) => (
              <div
                key={n.id}
                className={[styles.item, n.readAt ? '' : styles.itemUnread].join(' ')}
                onClick={() => {
                  if (!n.readAt) markReadMutation.mutate(n.id)
                  if (n.link) {
                    navigate(n.link)
                    setOpen(false)
                  }
                }}
              >
                <div className={styles.itemTitle}>{n.title}</div>
                {n.body ? <div>{n.body}</div> : null}
                <div className={styles.itemMeta}>{new Date(n.createdAt).toLocaleString('de-DE')}</div>
              </div>
            ))
          )}
        </div>
      ) : null}
    </div>
  )
}
